const getLatestData = () => {
    if (!window.dataLayer) {
        return;
    }
    return window.dataLayer.findLast(dl => !!dl.fieldsSimple)?.fieldsSimple;
}

const insurancesMap = {
    'p&c_liability': 'Haftpflichtversicherung',
    'p&c_contents': 'Hausratversicherung',
    'p&c_legal': 'Rechtsschutzversicherung',
    'l&h_health': 'Krankenversicherung',
    'l&h_dental': 'Zahnzusatzversicherung',
    'l&h_income': 'Berufsunfähigkeitsversicherung',
    'l&h_pension': 'Altersvorsorge',
    'travel': 'Auslandskrankenversicherung'
}


const buildCalendlyUrl = () => {
    let targetUrl = new URL('https://calendly.com/getsafe/ds_jobstarter')
    try {
        const latestData = getLatestData();
        targetUrl.searchParams.append('a2', latestData.study || '')
        targetUrl.searchParams.append('a3', latestData.loan || '')
        targetUrl.searchParams.append('a4', latestData.job || '')
        targetUrl.searchParams.append('a5', latestData.living || '')
        targetUrl.searchParams.append('a6', latestData.travel || '')
        targetUrl.searchParams.append('a7', latestData.insurances.split(', ').map(i => insurancesMap[i] || i).join(', '));
    } catch {}

    return targetUrl;
}

window.addEventListener('heyflow-screen-view', (event) => {
    if (event.detail.screenName === 'result') {
        try {
            const latestData = getLatestData();
            if (!latestData || !latestData.insurances) {
                window.location.hash = 'result-pc';
                return;
            }
            const insurances = latestData.insurances;
            if (insurances.includes('p&c')) {
                window.location.hash = 'result-pc';
            } else if (insurances.includes('l&h')) {
                window.location.hash = 'result-lh';
            } else if (insurances.includes('travel')) {
                window.location.hash = 'result-travel';
            } else {
                window.location.hash = 'result-pc';
            }
        } catch {
            window.location.hash = 'result-pc';
        }
    }
});

window.addEventListener('heyflow-button-click', (event) => {
    if (event.detail.customEventName === 'final_redirect') {
        let targetUrl = new URL('https://www.hellogetsafe.com/de-de')
        try {
            const latestData = getLatestData();
            if (latestData?.insurances) {
                if (latestData.insurances.includes('liability')) {
                    targetUrl.pathname = '/de-de/p/haftpflicht-de';
                } else if (latestData.insurances.includes('contents')) {
                    targetUrl.pathname = '/de-de/p/hausrat-de';
                } else if (latestData.insurances.includes('legal')) {
                    targetUrl.pathname = '/de-de/p/rechtsschutz-de';
                } else if (latestData.insurances.includes('health')) {
                    targetUrl = buildCalendlyUrl();
                    // targetUrl.pathname = '/de-de/p/privatekrankenversicherung-de';
                } else if (latestData.insurances.includes('dental')) {
                    targetUrl = buildCalendlyUrl();
                    // targetUrl.pathname = '/de-de/p/zahnzusatz-de';
                } else if (latestData.insurances.includes('income')) {
                    targetUrl = buildCalendlyUrl();
                    // targetUrl.pathname = '/de-de/p/berufsunfaehigkeit-de';
                } else if (latestData.insurances.includes('pension')) {
                    targetUrl = buildCalendlyUrl();
                    // targetUrl.pathname = '/de-de/p/privatealtersvorsorge-de';
                } else if (latestData.insurances.includes('travel')) {
                    targetUrl = new URL('https://product.hellogetsafe.com/de/travel-health');
                }
            }
            targetUrl.searchParams.append('coupon', 'DS2025');
            targetUrl.searchParams.append('campaign', 'liability1500');
            targetUrl.searchParams.append('utm_campaign', 'ds_heyflow');
            targetUrl.searchParams.append('utm_source', 'ds');
            targetUrl.searchParams.append('utm_medium', 'xsell');
        } catch {}

        window.open(targetUrl, '_blank');
    }
});